var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card-actions",
        {
          attrs: {
            "show-loading": _vm.fetchingPermitLicenses,
            title: "Vencimento do " + _vm.permitLicenseType.label,
            "action-collapse": "",
          },
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("b-table", {
                    ref: "permit-licenses-table-" + _vm.permitLicenseType.value,
                    staticClass: "bordered",
                    attrs: {
                      "show-empty": "",
                      responsive: "",
                      striped: "",
                      "empty-text": "Sem resultados",
                      fields: _vm.fields,
                      items: _vm.currentTypeData.permitLicenses,
                      "no-local-sorting": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "cell(tradingName)",
                        fn: function (row) {
                          return [
                            _c("e-router-link", {
                              attrs: {
                                title: _vm.$t("Loja"),
                                to: {
                                  name: "company-maintain",
                                  params: { id: row.item.companyId },
                                },
                                value:
                                  (row.item.identification ||
                                    row.item.companyId) +
                                  " - " +
                                  row.item.storeTradingName,
                              },
                            }),
                          ]
                        },
                      },
                      {
                        key: "cell(dueDate)",
                        fn: function (row) {
                          return [
                            _c("e-status-badge", {
                              attrs: {
                                variant: row.item.color,
                                type: "noOptions",
                                status: row.item.elapsedTime,
                              },
                            }),
                          ]
                        },
                      },
                      {
                        key: "cell(observation)",
                        fn: function (row) {
                          return [
                            _vm._v(" " + _vm._s(row.item.observation) + " "),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("e-pagination-summary", {
                    attrs: {
                      "current-page": _vm.getPagingByType(
                        _vm.permitLicenseType.value
                      ).currentPage,
                      "per-page": _vm.getPagingByType(
                        _vm.permitLicenseType.value
                      ).pageSize,
                      total: _vm.getPagingByType(_vm.permitLicenseType.value)
                        .rowCount,
                      "total-on-page": _vm.getPagingByType(
                        _vm.permitLicenseType.value
                      ).rowsInCurrentPage,
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                [
                  _c("b-pagination", {
                    attrs: {
                      value: _vm.getPagingByType(_vm.permitLicenseType.value)
                        .currentPage,
                      align: "right",
                      "total-rows": _vm.getPagingByType(
                        _vm.permitLicenseType.value
                      ).rowCount,
                      "per-page": _vm.getPagingByType(
                        _vm.permitLicenseType.value
                      ).pageSize,
                      "aria-controls":
                        "permit-licenses-table-" + _vm.permitLicenseType.value,
                    },
                    on: {
                      change: function (page) {
                        return _vm.onPageChangeByType(
                          _vm.permitLicenseType.value,
                          page
                        )
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }